'use strict';

import getNgModule from "getNgModule";
import Highcharts from "highcharts/highstock.src";
var ngModule = getNgModule(__filename);
ngModule.provider("$session", function () {
  // utilisateur loggé
  var user,
    // compte visualisé
    compte,
    // prod, recette, dev, ...
    environment,
    // habilitations liées au compte visualisé (se consulte via $authz.hasRole)
    habilitations,
    // Liens vers des applications externes (OpenCash, Localnova, ..)
    externalApplications,
    // module de subvnetion accessible sur au moins un compte accesible à l'utilisateur - pour la gestion de groupe
    moduleSubventionAccessible;
  return {
    $get: function $get($http) {
      return {
        $load: function $load() {
          return $http.get('/rest/authentication/session').then(function (response) {
            environment = response.data.environment;
            user = response.data.utilisateur;
            compte = response.data.compteVisualise;
            habilitations = response.data.habilitations;
            externalApplications = response.data.externalApplications;
            moduleSubventionAccessible = response.data.moduleSubventionAccessible;
            if (user.locale == null) {
              moment.locale("fr");
            } else {
              moment.locale(user.locale);
              numeral.language(user.locale);
              if (user.locale === 'en') {
                Highcharts.setOptions({
                  lang: Highcharts.translations['en_GB']
                });
              } else {
                Highcharts.setOptions({
                  lang: Highcharts.translations['fr_FR']
                });
              }
            }
          });
        },
        getUser: function getUser() {
          return user;
        },
        /**
         *
         * @returns le compte visualise
         */
        getCompte: function getCompte() {
          return compte;
        },
        /**
         * passer par $authz.hasr role pour consulter les habilitations
         * @returns {*}
         */
        getHabilitations: function getHabilitations() {
          return habilitations;
        },
        getExternalApplications: function getExternalApplications() {
          return externalApplications;
        },
        isModuleSubventionAccessible: function isModuleSubventionAccessible() {
          return moduleSubventionAccessible;
        },
        /**
         *
         * @returns {boolean} true si le compte possède des comptes fils liés
         */
        possedeComptesLies: function possedeComptesLies() {
          return _.keys(this.getCompte().comptesLies).length > 0;
        },
        isNommageBudget: function isNommageBudget() {
          return !this.getCompte().budgetAsOperation;
        },
        isNommageOperation: function isNommageOperation() {
          return this.getCompte().budgetAsOperation;
        },
        getEnvironment: function getEnvironment() {
          return environment;
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/security/$session.js
// module id = 2722
// module chunks = 13